import * as types from '../mutation-types'

// initial state
const state = {
  token: null,
  online: false
}

// getters
const getters = {
  online: state => state.online,
  token: state => state.token
}

// actions
const actions = {
}

// mutations
const mutations = {
  storeToken (state, payload) {
    sessionStorage.setItem('token', payload.token)
    var date = new Date().getTime()
    var now = Math.floor(date / 1000)
    sessionStorage.setItem('token_exp_time', (now + types.TOKEN_LIFE_TIME).toString())
    state.token = payload.token
  },
  deleteToken (state) {
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('token_exp_time')
  },
  refresh (state) {
    if (getters.token) {
      var expTime = 0
      expTime = parseInt(sessionStorage.getItem('token_exp_time'))

      var date = new Date().getTime()
      var now = Math.floor(date / 1000)
      state.online = expTime > now
      if (state.online) {
        sessionStorage.setItem('token_exp_time', (now + types.TOKEN_LIFE_TIME).toString())
      }
    } else {
      state.online = false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
